export default function Description() {
  return (
    <p className="clr-white">
      At Innovation Academy, we equip students with the skills and knowledge to
      excel in the ever-evolving world of technology. Let's shape the future
      together.
    </p>
  );
}
